import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { UpcomingWork } from '@jms/model';
import { BadgeComponent } from '@workbuddy/ui/components/badge';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { DateTime } from 'luxon';
import { upcomingWorkVisitDateBridgeStyles, upcomingWorkVisitDateStyleId } from './upcoming.work.visit.date.theme';

@Component({
  selector: 'wb-upcoming-work-visit-date',
  imports: [BadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span>{{ $date() }}</span>
    @if ($originalDate()) {
      <w-badge size="xs" label="Rescheduled" [tooltip]="$tooltip()"
        color="var(--local-upcoming-work-visit-date-text)"
        backgroundColor="var(--local-upcoming-work-visit-date-background)"
        borderColor="var(--local-upcoming-work-visit-date-border)" />
    }
  `,
  styleUrl: './upcoming.work.visit.date.cell.renderer.less',
})
export class UpcomingWorkVisitDateCellRenderer implements ICellRendererAngularComp {
  private readonly document = inject(DOCUMENT);
  protected readonly $date = signal('');
  protected readonly $originalDate = signal('');
  protected readonly $tooltip = computed(() => `Moved from ${this.$originalDate()}. Regular schedule unchanged.`);

  public constructor() {
    DesignSystem.Mount(this.document, upcomingWorkVisitDateStyleId, upcomingWorkVisitDateBridgeStyles);
  }

  public agInit(params: ICellRendererParams<UpcomingWork>): void {
    const date = DateTime.fromISO(params.data?.visitDate ?? '', { zone: 'utc' });
    const original = DateTime.fromISO(params.data?.originalVisitDate ?? '', { zone: 'utc' });
    this.$date.set(params.valueFormatted ?? (date.isValid ? date.toFormat('dd/MM/yyyy') : ''));
    this.$originalDate.set(original.isValid && original.toISODate() !== date.toISODate() ? original.toFormat('d LLL yyyy') : '');
  }

  public refresh(params: ICellRendererParams<UpcomingWork>): boolean {
    this.agInit(params);
    return true;
  }
}
